<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-12 col-lg-7 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <h5 class="card-title">Categorias</h5>
                </div>
                <div class="card-body card-buttons">
                    <b-form action="javascript:;">

                        <div class="row">
                            <div class="col-12">
                                <label class="col-form-label">Nombre</label>
                                <b-form-input v-model="nombre" type="text" class="form-control"
                                    :class="{ 'is-invalid': !isNombreValido && nombreTouched }"
                                    placeholder="Nombre de la categoría" required @blur="nombreTouched = true" />
                            </div>

                            <div class="col-12 mt-2">
                                <label class="col-form-label">Imagen</label>
                                <input class="form-control" type="file" @change="handleImageUpload" accept="image/*" />

                                <div v-if="imagePreview" class="mt-3 text-center text-lg-start">
                                    <img :src="imagePreview" alt="Vista previa de la imagen" class="img-thumbnail"
                                        style="max-width: 200px; max-height: 200px;" />
                                </div>
                            </div>
                        </div>
                        <div class="text-end mt-3">
                            <b-button v-if="!isEditing" @click="submitForm" class="btn-primary m-1"
                                :disabled="!isNombreValido || isLoading">
                                Guardar
                            </b-button>
                            <b-button v-if="isEditing" @click="updateCategory" :disabled="!isNombreValido || isLoading"
                                class="btn-edit m-1">Actualizar</b-button>
                            <b-button v-if="isEditing" @click="deleteCategory"
                                class="btn-danger m-1">Eliminar</b-button>
                            <b-button @click="resetForm" class="btn-clean m-1">Limpiar</b-button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-5 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-center">
                        <div class="col">
                            <h5 class="card-title">Lista de Categorías</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-stripped table-hover">
                            <tbody>
                                <tr v-for="category in categories" :key="category.id">
                                    <td @click="option(category)">
                                        <h2 class="table-avatar">
                                            <li class="company-avatar avatar-md me-2 companies company-icon">
                                                <img class="avatar-img rounded-circle company"
                                                    :src="baseURL + '/categoria/image/' + category.imagen.split('/').pop()"
                                                    :alt="category.nombre" />
                                            </li>
                                            <a>{{ category.nombre }}
                                                <span class="plane-type">{{ category.slug }}</span>
                                            </a>
                                        </h2>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {

    data() {
        return {
            nombreTouched: false,
            categoriaId: null,
            categories: [],
            nombre: '',
            imagePreview: null,
            selectedImage: null,
            isLoading: false,
            error: null,
            isEditing: false,
            originalImage: null,
            baseURL: api.defaults.baseURL,
        };
    },
    mounted() {
        this.loadCategories();
    },

    methods: {
        async loadCategories() {
            try {
                const response = await api.get('/categoria');
                this.categories = response.data;
            } catch (err) {
                this.error = 'Error al cargar categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async submitForm() {

            const result = await this.$swal.fire({
                title: '¿Guardar categoría?',
                text: 'Se guardará una nueva categoría.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            const formData = new FormData();
            if (this.selectedImage) {
                formData.append("imagen", this.selectedImage);
            }
            formData.append("nombre", this.nombre);

            try {
                const response = await api.post("/categoria", formData);
                this.isLoading = false;
                this.$toast.success('Categoría agregada con éxito');
                this.nombre = "";
                this.imagePreview = null;
                this.selectedImage = null;
                this.loadCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al agregada la categoría');
            }
        },
        handleImageUpload(event) {
            const file = event.target.files[0]; // Obtiene el archivo seleccionado

            if (file) {
                this.selectedImage = file; // Guarda el archivo para enviarlo luego

                // Crea una URL temporal para la vista previa
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.imagePreview = null;
                this.selectedImage = null;
            }
        },
        option(category) {
            this.isEditing = true;
            this.categoriaId = category.id;
            this.nombre = category.nombre;

            this.originalImage = category.imagen;

            if (category.imagen) {
                this.imagePreview = `${this.baseURL}/categoria/image/${category.imagen.split('/').pop()}`;
            } else {
                this.imagePreview = null;
            }

            this.selectedImage = null;
        },
        async updateCategory() {

            const result = await this.$swal.fire({
                title: '¿Actualizar categoría?',
                text: 'Se modificará la categoría seleccionada.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, actualizar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;

            this.isLoading = true;

            const formData = new FormData();
            formData.append("nombre", this.nombre);

            if (this.selectedImage) {
                formData.append("imagen", this.selectedImage);
            }

            try {
                const response = await api.put(`/categoria/${this.categoriaId}`, formData);
                this.isLoading = false;
                this.$toast.success('Categoría actualizada con éxito');
                this.resetForm();
                this.loadCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al actualizar categoría');
                console.error("Error:", error);
            }
        },
        async deleteCategory() {

            const result = await this.$swal.fire({
                title: '¿Eliminar categoría?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            try {
                const response = await api.delete(`/categoria/${this.categoriaId}`);
                this.isLoading = false;
                this.$toast.success('Categoría eliminada con éxito');
                this.resetForm();
                this.loadCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al eliminar categoría');
                console.error("Error:", error);
            }
        },

        resetForm() {
            this.nombreTouched = false;
            this.categoriaId = '';
            this.nombre = '';
            this.imagePreview = null;
            this.selectedImage = null;
            this.isEditing = false;
            this.originalImage = null;
        },
    },
    computed: {
        isNombreValido() {
            return this.nombre.trim().length > 0;
        }
    }

};
</script>

<style>
td {
    cursor: pointer;
    transition: background-color 0.2s;
}

td:hover {
    background-color: #f5f5f5;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}
</style>
